const InboxStatus = {
  youHaveReceived: "You have",
  newMessages: "new message",
  morethanewMessages: "new messages",
  zeronewMessages: "new messages",
  no: "0",
  view: "View ",
  viewAriaLabel: "View new messages"
};

export default InboxStatus;
